/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Plan_RestInputs */

const en_us2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s rest`)
};

const pt_br2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso`)
};

const es_419_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso`)
};

const pt_pt2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de descanso`)
};

const fr_fr2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s de repos`)
};

const de_de2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s Pause`)
};

const it_it2_plan_rest = /** @type {(inputs: Plan_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s di recupero`)
};

/**
* | output |
* | --- |
* | "{seconds} s rest" |
*
* @param {Plan_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_rest = /** @type {((inputs: Plan_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_rest(inputs)
	if (locale === "es-419") return es_419_plan_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_rest(inputs)
	if (locale === "de-DE") return de_de2_plan_rest(inputs)
	if (locale === "it-IT") return it_it2_plan_rest(inputs)
	return en_us2_plan_rest(inputs)
});
export { plan_rest as "plan.rest" }